export default {
    parent: 'ReviewLayout',
    url: '/performance-review/:guid',
    template: `
        <review-default review="vm.review" />
        `,
    resolve: {
        review ($stateParams, ReviewResource, ReviewService) {
            return ReviewResource.publicView({ guid: $stateParams.guid, expand: ReviewService.getExpandString() }).$promise;
        }
    },
    controller ($rootScope, $stateParams, $scope, ReviewService, MomentService, review, REVIEW_LAYOUT_ENUM, WindowConfirmService) {
        this.REVIEW_LAYOUT_ENUM = REVIEW_LAYOUT_ENUM;
        ReviewService.loadAdditionalData(review);
        this.review = review;
        this.review.reviewDate = MomentService.formatTimeStamp(review.reviewDate, 'YYYY-MM-DD HH:mm:00', true);
        $rootScope.review = review;

        // this is used to populate header with required data
        $scope.$emit('review', review);
        $scope.$on('review:reload', (event, updatedReview) => {
            ReviewService.loadAdditionalData(updatedReview);
            this.review = updatedReview;
            this.review.reviewDate = MomentService.formatTimeStamp(updatedReview.reviewDate, 'YYYY-MM-DD HH:mm:00', true);
        });

        // ask confirmation if user refresh
        WindowConfirmService.activate();
    }
};



// WEBPACK FOOTER //
// ./src/app/states/review/index.js